import type { BootFallbackGridSpec } from "@slot/game-shell";

// REELS: 5 reels (columns) × 4 rows. Symbols from the loaded atlas (L1-L5,
// H1-H4). Low-symbol heavy, mixed per reel so no single symbol stacks a column,
// and varied enough to read as a normal idle board. (Rows separated by '|',
// columns by ',' — the platform's `DelimitedGridCodec`, which throws at the
// boot paint if this is not 5×4.)
export const BOOT_FALLBACK_GRID: BootFallbackGridSpec = {
  encodedGridSnapshot:
    "L1,L2,L5,H1,L3|" +
    "L4,L5,L2,L1,L5|" +
    "L3,L1,L4,L5,L2|" +
    "L2,L4,L1,L3,L4",
  reelSetIdentifier: "default",
};
